var storage={
    set(key,value){
        localStorage.setItem(key,JSON.stringify(value));
    },
    get(key){
        var result  = localStorage.getItem(key);
        if(result!=null){
            try{
                result =  JSON.parse(localStorage.getItem(key));
            }catch(e){
                result = localStorage.getItem(key);
            }
        }
        return result == null?'':result;
    },
    remove(key){
        localStorage.removeItem(key);
    }
}
export default storage;


// WEBPACK FOOTER //
// ./src/store/storage.js